import { AfterViewInit, Component, inject, Input } from '@angular/core';
import { JointListItemDto } from '@therapist/shared/models/diagnosis/joint-list-item.dto';
import { JointNameTranslationsPipe } from '@therapist/shared/pipes/joint-name-translations/joint-name-translations.pipe';

@Component({
  selector: 'sana-tp-joint-badge',
  imports: [],
  templateUrl: './joint-badge.component.html',
  styleUrl: './joint-badge.component.scss',
  providers: [JointNameTranslationsPipe]
})
export class JointBadgeComponent implements AfterViewInit {

  readonly #jointNameTranslationsPipe = inject(JointNameTranslationsPipe);

  @Input({ required: true }) joints!: JointListItemDto[];

  jointNames = '';

  ngAfterViewInit() {
    this.jointNames = this.joints.map(joint => this.#jointNameTranslationsPipe.transform(joint.type)).join(', ');
  }
}
